
export enum PageId {
    NONE = 'NONE',
    HOME_PAGE_ID =  'HOME_PAGE_ID',
    ENROLLMENT_PAGE_ID =  'ENROLLMENT_PAGE_ID',
    LOGIN_PAGE_ID =  'LOGIN_PAGE_ID',
    RESET_PASSWORD_PAGE_ID =  'RESET_PASSWORD_PAGE_ID',
    RENEW_PASSWORD_PAGE_ID =  'RENEW_PASSWORD_PAGE_ID',
    CONTACT_PAGE_ID =  'CONTACT_PAGE_ID',
    PRESS_PAGE_ID =  'PRESS_PAGE_ID',
    ACCOUNT_PAGE_ID =  'ACCOUNT_PAGE_ID',
    START_ENROLLMENT_PAGE_ID =  'START_ENROLLMENT_PAGE_ID',
    CHANGE_PASSWORD_PAGE_ID =  'CHANGE_PASSWORD_PAGE_ID',
    CHANGE_EMAIL_PAGE_ID =  'CHANGE_EMAIL_PAGE_ID',
    CHANGE_PHONE_NUMBER_PAGE_ID =  'CHANGE_PHONE_NUMBER_PAGE_ID',
    CREATE_SOUSCRIPTION_PAGE_ID = 'CREATE_SOUSCRIPTION_PAGE_ID',
    SUIVI_VENTES_PAGE_ID = 'SUIVI_VENTES_PAGE_ID',
    SOUSCRIPTION_SUIVI_PAGE_ID = 'SOUSCRIPTION_SUIVI_PAGE_ID',
}

export function pageIdOf(stringValue: string | null) : PageId {

    if (stringValue===null) {
        return PageId.NONE;
    }

    switch (stringValue) {
        case 'NONE':
            return PageId.NONE;

        case 'HOME_PAGE_ID':
            return PageId.HOME_PAGE_ID;

        case 'ENROLLMENT_PAGE_ID':
            return PageId.ENROLLMENT_PAGE_ID;

        case 'LOGIN_PAGE_ID':
            return PageId.LOGIN_PAGE_ID;

        case 'RESET_PASSWORD_PAGE_ID':
            return PageId.RESET_PASSWORD_PAGE_ID;

        case 'RENEW_PASSWORD_PAGE_ID':
            return PageId.RENEW_PASSWORD_PAGE_ID;

        case 'CONTACT_PAGE_ID':
            return PageId.CONTACT_PAGE_ID;

        case 'PRESS_PAGE_ID':
            return PageId.PRESS_PAGE_ID;

        case 'ACCOUNT_PAGE_ID':
            return PageId.ACCOUNT_PAGE_ID;

        case 'START_ENROLLMENT_PAGE_ID':
            return PageId.START_ENROLLMENT_PAGE_ID;

        case 'CHANGE_PASSWORD_PAGE_ID':
            return PageId.CHANGE_PASSWORD_PAGE_ID;

        case 'CHANGE_EMAIL_PAGE_ID':
            return PageId.CHANGE_EMAIL_PAGE_ID;

        case 'CHANGE_PHONE_NUMBER_PAGE_ID':
            return PageId.CHANGE_PHONE_NUMBER_PAGE_ID;

        case 'CREATE_SOUSCRIPTION_PAGE_ID':
            return PageId.CREATE_SOUSCRIPTION_PAGE_ID;

        case 'SUIVI_VENTES_PAGE_ID':
            return PageId.SUIVI_VENTES_PAGE_ID;

        case 'SOUSCRIPTION_SUIVI_PAGE_ID':
            return PageId.SOUSCRIPTION_SUIVI_PAGE_ID;

        default:
            return PageId.NONE;
    }
}

